<template>
  <div>
    <HeaderNav />
    <router-view />
    <FooterNav /> <!-- 新增：底部 Footer -->
    <Consultation/> <!-- 新增：咨询组件 -->
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue'
import FooterNav from '@/components/FooterNav.vue' // 引入
import Consultation from '@/components/Consultation.vue'

export default {
  name: 'App',
  components: {
    HeaderNav,
    FooterNav, // 注册
    Consultation // 注册
  }
}
</script>
<style>
/* 全局重置：去掉所有默认边距 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* {
  /* cursor: default !important; */
  user-select: none !important; /* 同时禁止选中文字，更像官网 */
}
/* 去掉 body 默认边距 */
body {
  margin: 0;
  padding: 0;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  /* 全局默认文字颜色 */
  color: #333;
  /* 禁止横向滚动条 */
  overflow-x: hidden;
}

/* 全局链接样式 */
a {
  text-decoration: none;
}

/* 全局清除列表样式 */
ul, ol {
  list-style: none;
}
</style>

<!-- 组件内样式可以继续写 scoped -->
<style scoped>
#app {
  min-height: 100vh;
}
</style>